export type AiSamplePurpose =
  | "schema-inference"
  | "converter-schema"
  | "public-playground";

export async function uploadAiSample(
  file: File,
  purpose: AiSamplePurpose,
): Promise<string> {
  const response = await fetch("/api/upload/samples", {
    method: "PUT",
    headers: {
      "content-type": "application/pdf",
      "x-file-name": file.name,
      "x-upload-purpose": purpose,
    },
    body: file,
  });
  const payload = (await response.json().catch(() => null)) as {
    sampleId?: string;
    error?: string;
  } | null;
  if (!response.ok || !payload?.sampleId) {
    throw new Error(payload?.error ?? "Unable to upload the PDF sample.");
  }
  return payload.sampleId;
}
